import { JourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard, NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { getDescriptionText, useDescription } from './helpers';

const ACTION_TYPE = ACTION_TYPES.wait_for_attribute_change;

export const getDescription = (action: JourneyAction<typeof ACTION_TYPE>): string => {
  return getDescriptionText({ values: action.values, styled: false, translations: nodeLocale });
};

export const Node = (node: JourneyNode<typeof ACTION_TYPE>) => {
  const values = node.data?.values;
  const isConfigured = node.data?.isConfigured;
  const { descriptionText } = useDescription(values, nodeLocale);
  const description = node.data?.description?.trim();
  const hasDescription = Boolean(description);

  const tooltip =
    isConfigured && !hasDescription
      ? getDescriptionText({ values, styled: false, translations: nodeLocale })
      : '';

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={description || descriptionText}
        tooltip={tooltip}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    configureAction: 'Configure action',
    continueWhen: 'Continue when\n',
    continueWhenNoStyle: 'Continue when\n{field} {comparator} {value}',
    conditionDescription: '{field} {comparator} {value}',
    changesValue: 'changes',
  },
};
